<section
  *transloco="let t"
  class="reset-password-container"
  [class.error]="submitted && !loading && failed"
  [class.ios-app]="redirect"
  [class.dialog]="inDialog"
  [class.small-mobileL]="(lessThan$ | async)?.mobileL"
  [class.small-xs]="(lessThan$ | async)?.xs">
  <nav class="dialog-head" *ngIf="inDialog">
    <button
      type="button"
      mat-flat-button
      class="button"
      [class.rtl]="isRtlLayout$ | async"
      (click)="changeDialogMode('sign-in')">
      <popsy-icon-remove class="icon gray-dark" aria-hidden="true"></popsy-icon-remove>
    </button>
    <div aria-hidden="true" class="dynamic-space"></div>
    <button type="button" mat-flat-button class="button small" (click)="close(true)">
      <popsy-icon-remove class="icon gray-dark" aria-hidden="true"></popsy-icon-remove>
    </button>
  </nav>
  <form
    *ngIf="!(submitted && success)"
    class="form"
    name="reset-password"
    (ngSubmit)="resetPassword()">
    <h2 class="title">{{ t('title_reset_password') }}</h2>
    <h3 class="subtitle">{{ t('subtitle_reset_password') }}</h3>
    <div class="form-field" floatLabel="always" shouldLabelFloat hideRequiredMarker>
      <span class="label">{{ t('hint_email') }}</span>
      <input
        data-clarity-unmask
        #email
        matInput
        type="email"
        class="field"
        [formControl]="emailFromControl"
        inputmode="email"
        autocomplete="email"
        required />
      <span class="error" *ngIf="emailFromControl.hasError('required')">
        {{ t('error_email_required') }}
      </span>
      <span class="error" *ngIf="emailFromControl.hasError('email')">
        {{ t('error_email_not_valid') }}
      </span>
      <span class="error" *ngIf="emailFromControl.hasError('USER_NOT_FOUND')">
        {{ t('error_login_does_not_exist') }}
      </span>
      <span class="error" *ngIf="emailFromControl.hasError('USER_BANNED')">
        {{ t('error_login_does_not_exist') }}
      </span>
      <span class="error" *ngIf="emailFromControl.hasError('UNKNOWN')">
        {{ t('error_login_unknown') }}
      </span>
    </div>

    <div aria-hidden="true" class="dynamic-space"></div>
    <button
      type="submit"
      class="button popsy-button-primary"
      [class.error]="submitted && failed"
      [class.success]="submitted && success"
      (click)="resetPassword()"
      [disabled]="emailFromControl?.status !== 'VALID'">
      <app-loading class="spinner" *ngIf="loading"></app-loading>
      <span *ngIf="!loading" class="message">{{ t('button_reset_password') }}</span>
    </button>
  </form>
  <div *ngIf="submitted && success" class="check-your-email">
    <popsy-icon-check-email
      class="illustration"
      aria-hidden="true"></popsy-icon-check-email>
    <div class="message">
      <h2 class="title">{{ t('mesage_forgot_confirmation') }}</h2>
      <h3 class="description">{{ t('message_reset_password') }}</h3>
      <div aria-hidden="true" class="dynamic-space"></div>
      <p class="info" [innerHTML]="helpText"></p>
    </div>
  </div>
</section>
